module.exports = __webpack_public_path__ + "static/img/logo01.ddccd86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/rickle/logo01.png
// module id = hHXq
// module chunks = 0